export default "__VITE_ASSET__CYy14uhU__"